import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';

interface PanelSectionProps {
  title: string;
  /** Sunto mostrato accanto al titolo quando la sezione è chiusa. */
  summary?: string;
  /** Conteggio mostrato tra parentesi accanto al titolo. */
  count?: number;
  /** Azione a destra del titolo (es. "Aggiorna" su Altri campi). */
  action?: { label: string; onClick: () => void };
  defaultOpen?: boolean;
  children: React.ReactNode;
}

/**
 * Toggle di sezione del pannello dettagli lead/cliente: stesso linguaggio del
 * drawer "Nuova anagrafica" (chevron rosa Flusia, titolo maiuscoletto grigio,
 * sunto inline quando chiusa) più azione opzionale a destra.
 */
export function PanelSection({ title, summary, count, action, defaultOpen = false, children }: PanelSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="mt-1">
      <div className="flex items-center gap-1.5 -mx-1.5">
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
          className="flex min-w-0 flex-1 items-center gap-1.5 rounded px-1.5 py-1.5 text-left hover:bg-[rgba(55,53,47,0.08)] dark:hover:bg-white/[0.06] transition-colors"
        >
          <ChevronRight
            className={`w-3.5 h-3.5 flex-shrink-0 text-[#E91E8C] transition-transform ${open ? 'rotate-90' : ''}`}
            strokeWidth={2}
          />
          <span className="whitespace-nowrap text-[11px] font-medium uppercase tracking-wide text-[rgba(55,53,47,0.5)] dark:text-gray-400">
            {title}
          </span>
          {count !== undefined && (
            <span className="text-[11px] text-[rgba(55,53,47,0.4)] dark:text-gray-500">({count})</span>
          )}
          {!open && summary && (
            <span className="ml-1.5 min-w-0 truncate text-[12.5px] text-[#787774] dark:text-gray-400">{summary}</span>
          )}
        </button>
        {action && (
          <button
            type="button"
            onClick={action.onClick}
            className="flex-shrink-0 rounded px-1.5 py-1 text-[11px] text-[#787774] hover:bg-[rgba(55,53,47,0.08)] hover:text-[#37352F] dark:text-gray-400 dark:hover:bg-white/[0.06] dark:hover:text-white transition-colors"
          >
            {action.label}
          </button>
        )}
      </div>
      {open && <div className="pt-1 pb-2">{children}</div>}
    </div>
  );
}
